<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!--Header-->
							<div class="page_header">Add/Edit CAPA Operation</div>
							<!--Header-->
							<div class="page_main">
								<el-form ref="resForm" :model="form" :rules="rules1" label-position="top" class="request-form">
									<el-form-item label="CAPA ID" class="full-width-item">
										<div class="gray-input">
											{{ info.request_id || "/" }}
										</div>
									</el-form-item>
									<div class="form-grid">
										<!-- Left -->
										<div class="form-col">
											<el-form-item label="Status">
												<div class="gray-input">
													{{ info.status_name }}
												</div>
											</el-form-item>
											<el-form-item label="Priority">
												<div class="gray-input">
													<span v-if="info.priority == 1">High</span>
													<span v-if="info.priority == 2">Medium</span>
													<span v-if="info.priority == 3">Low</span>
													<span v-if="!info.priority">/</span>
												</div>
											</el-form-item>
											<el-form-item label="Investigator">
												<div class="gray-input">
													{{ info.investigator }}
												</div>
											</el-form-item>
										</div>
										<!-- Right -->
										<div class="form-col">
											<el-form-item label="Request Date">
												<div class="gray-input">
													{{ info.time1 || "/" }}
												</div>
											</el-form-item>
											<el-form-item label="Acceptance Date">
												<div class="gray-input">
													{{ info.time2 || "/" }}
												</div>
											</el-form-item>
											<el-form-item label="Investigation Start Date">
												<div class="gray-input">
													{{ info.time3 || "/" }}
												</div>
											</el-form-item>
										</div>
									</div>
									<div class="text-tip">CAPA Description</div>
									<el-form-item label="Description of the issue, concern, idea, or opportunity" class="full-width-item">
										<div class="gray-input">
											{{ info.description || "/" }}
										</div>
									</el-form-item>
									<div class="file-panel">
										<div class="panel-header">
											<div class="table-title">Correction</div>
										</div>
										<el-table :data="correctionTableData" border stripe header-cell-class-name="table-header-cell" class="file-table" empty-text="No Correction">
											<el-table-column prop="description" label="Correction Description" min-width="260" sortable />
											<el-table-column prop="" label="Correction File" min-width="180">
												<template slot-scope="scope">
													<a :href="scope.row.url" target="_blank">{{ scope.row.name }}</a>
												</template>
											</el-table-column>
										</el-table>
									</div>
									<div class="text-tip" style="margin-top: 20px">
										Root Cause Action Summary
									</div>
									<el-card shadow="never">
										<!-- Root Cause -->
										<div class="section">
											<div class="text-tip">Root Cause</div>
											<el-form label-position="top">
												<el-form-item label="Root Cause Analysis Result">
													<div class="gray-input">{{ info.rootResult }}</div>
												</el-form-item>
											</el-form>
										</div>
										<!-- Corrective Action: Dynamic Rendering -->
										<div v-for="(item, index) in info.correctiveActions" :key="index" class="section">
											<div class="text-tip">{{ item.capa_type == 1 ? 'Corrective Action' : 'Preventive Action' }}</div>
											<el-form label-position="top">
												<el-form-item label="Action Implementation Notes">
													<div class="gray-input">{{ item.implementation_instructions }}</div>
												</el-form-item>
											</el-form>
										</div>
									</el-card>
									<!-- Root Cause Form -->
									<div class="input_el" style="margin-top: 20px">
										<div class="tit required">Action Type</div>
										<el-form-item label="" prop="capa_type">
											<el-select v-model="form.capa_type" placeholder="Please select" clearable class="full-width">
												<el-option label="Corrective Action" :value="1" />
												<el-option label="Preventive Action" :value="2" />
											</el-select>
										</el-form-item>
									</div>
									<div class="input_el">
										<div class="tit required">Action Implementation Notes</div>
										<el-form-item label="" prop="implementation_instructions">
											<el-input v-model="form.implementation_instructions" type="textarea" :rows="5" placeholder="Please enter" />
										</el-form-item>
									</div>
									<div class="input_el" style="margin-top: 20px">
										<div class="tit required">Task Owner</div>
										<el-form-item label="" prop="implementor">
											<el-select filterable v-model="form.implementor" placeholder="Please select" class="full-width" clearable>
												<el-option v-for="value in usersList" :key="value.id" :label="value.username" :value="value.id"></el-option>
											</el-select>
										</el-form-item>
									</div>
									<div class="input_el">
										<div class="tit required">Planned Action Due Date</div>
										<el-form-item label="" prop="end_time">
											<el-date-picker v-model="form.end_time" type="date" placeholder="Please select" style="width: 100%">
											</el-date-picker>
										</el-form-item>
									</div>
									<div class="tip-box">
										Please provide an explanation and objective evidence that this action has been completed.
									</div>
									<div class="input_el">
										<div class="tit required">Operation Verification Notes</div>
										<el-form-item label="" prop="verification_instructions">
											<el-input v-model="form.verification_instructions" type="textarea" :rows="5" placeholder="Please enter" />
										</el-form-item>
									</div>
									<div class="file-panel">
										<div class="panel-header">
											<div class="table-title">Affected Files</div>
										</div>
										<el-table :data="affectedFiles" border stripe header-cell-class-name="table-header-cell" class="file-table"
											empty-text="No Affected Files">
											<el-table-column prop="" label="Description" sortable min-width="200">
												<template slot-scope="scope">
													<div>{{ scope.row.description || "/" }}</div>
												</template>
											</el-table-column>
											<el-table-column prop="fileName" label="File Name" min-width="240">
												<template slot-scope="scope">
													<a :href="scope.row.url" target="_blank">{{ scope.row.name }}</a>
												</template>
											</el-table-column>
											<el-table-column prop="id" label="Operation" width="80" align="center">
												<template #default="scope">
													<div class="inline_btn">
														<el-button type="danger" size="mini"
															@click="handleRemove(scope.row)">
															Delete
														</el-button>
													</div>
												</template>
											</el-table-column>
										</el-table>
										<el-button type="primary" size="mini" style="margin: 10px"
											@click="handleAffectFile('resForm')">
											Add Affected Document
										</el-button>
									</div>
								</el-form>
								<!-- Bottom Buttons -->
								<div class="footer-actions">
									<el-button type="primary" size="small" @click="submitForm1('resForm')">
										Save
									</el-button>
									<el-button type="primary" size="small" @click="handleCancel">
										Cancel
									</el-button>
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--Add File Dialog-->
		<el-dialog title="Add Affected Document" :visible.sync="dialogVisible" width="50%">
			<div class="save_box">
				<div class="form_box">
					<div style="padding-bottom: 20px; font-weight: bold; font-size: 16px">
						Please complete the following information
					</div>
					<el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-position="top" class="upload-form">
						<!-- Description -->
						<el-form-item label="Description" prop="description">
							<el-input v-model="ruleForm.description" type="textarea" :rows="5" resize="none"
								placeholder="Please enter a description" />
						</el-form-item>
						<!-- Attachment -->
						<el-form-item prop="">
							<div class="upload-doc-wrapper">
								<div class="upload-title">
									<span> Files to Upload </span>
									<span class="upload-limit"> （Max 10 MB) </span>
								</div>
								<div class="upload-box" style="position: relative">
									<el-upload
										ref="uploadBox"
										class="doc-upload"
										action="/"
										name="files"
										:show-file-list="false"
										:before-upload="beforeAvatarUpload"
										:on-change="handleAvatarChange"
										:limit="1"
										:with-credentials="true"
										:auto-upload="false"
									>
										<el-button size="medium" class="select-btn">
											Select File
										</el-button>
									</el-upload>
									<div class="file-name" :class="{ placeholder: !fileName }">
										{{ fileName || "No File Selected" }}
										<span v-if="fileName" style="position: absolute; right: 20px; top: 12px; cursor: pointer;color: #f00;" @click="delFile">Delete</span>
									</div>
								</div>
							</div>
						</el-form-item>
					</el-form>
				</div>
				<div class="btn_box">
					<van-button class="btn_el" type="default" round @click="dialogVisible = false">
						Cancel
					</van-button>
					<van-button class="btn_el" round color="linear-gradient(to right, #7BC1FF, #4886FF)"
						@click="submitForm('ruleForm')">
						Confirm
					</van-button>
				</div>
			</div>
		</el-dialog>
		<!--Add File Dialog-->
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading />
			</div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import {
	resourcesApplyDetail
} from "@/api/docManage/changeRequest/index";
import {
	capaRootCauseDetail,
	capaRootCauseActionAdd,
	capaRootCauseActionDetail,
	capaUploadsRootCauseActionFile,
	capaUploadsRootCauseActionFileDel
} from "@/api/capaManage/capaRequest/index";
import { usersList } from '@/api/system/user';
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
import moment from 'moment';
export default {
	components: {
		headers,
		slider,
	},
	data() {
		return {
			isLoading: true,
			dialogVisible: false,
			keyword: "",
			searchKeyword: "",
			fileName: "",
			selectedFile: null,
			info: {},
			form: {
				id: '',
				root_cause_id: '',
				capa_type: '',
				implementation_instructions: '',
				verification_instructions: '',
				implementor: '',
				end_time: '',
			},
			correctionTableData: [],
			affectedFiles: [],
			usersList: [],
			userToken: localStorage.getItem("userToken"),
			ruleForm: {
				id: "",
				description: "",
				fileUrl: "",
			},
			rules: {
				description: [{
					required: true,
					message: "Please enter comments",
					trigger: "blur"
				}, ],
			},
			rules1: {
				capa_type: [{
					required: true,
					message: "Please select",
					trigger: "change"
				}],
				implementation_instructions: [{
					required: true,
					message: "Please enter",
					trigger: "blur"
				}, ],
				verification_instructions: [{
					required: true,
					message: "Please enter",
					trigger: "blur"
				}, ],
				implementor: [{
					required: true,
					message: "Please select",
					trigger: "change"
				}],
				end_time: [{
					required: true,
					message: "Please select",
					trigger: "change"
				}]
			},
		};
	},
	mounted() {
		let that = this;
		if(that.$route.query.id) {
			that.form.id = that.$route.query.id;
		}
		that.form.root_cause_id = that.$route.query.rootCaseId;
		//Request User List
		usersList({ page: 1, page_size: 9999, status: 1 }).then(res => {
			that.usersList = res.data.data;
		});
		that.isLoading = false;
		that.getPageInfo();
	},
	methods: {
		//Get Page Details
		getPageInfo() {
			let that = this;
			resourcesApplyDetail({ id: that.$route.query.oid }).then(res => {
				if(res.code == 200) {
					// console.log(res.data);
					that.info = {
						id: res.data.id,
						request_id: res.data.request_id,
						status_name: res.data.status_name,
						priority: res.data.priority,
						investigator: res.data.investigator,
						description: res.data.description,
						username: res.data.username,
						// company_name: res.data.company_name,
						source_type: res.data.source_type,
						departments_name: res.data.departments_name,
						source_info: res.data.source_info,
						time1: res.data.time1,
						time2: res.data.time2,
						time3: res.data.time3,
						rootResult: '',
						correctiveActions: []
					};
					that.correctionTableData = res.data.capacorrections_list;
					//Request Root Cause Details
					capaRootCauseDetail({ id: that.form.root_cause_id }).then(res2 => {
						if(res.code == 200) {
							// console.log(res2.data);
							that.info.rootResult = res2.data.analysis_results;
							that.info.correctiveActions = res2.data.capa_root_cause_action_list;
							if(that.form.id) {
								//Get Details
								capaRootCauseActionDetail({ id: that.form.id }).then(res3 => {
									if(res3.code == 200) {
										// console.log(res3.data);
										that.form.id = res3.data.id;
										that.form.capa_type = res3.data.capa_type;
										that.form.implementation_instructions = res3.data.implementation_instructions;
										that.form.verification_instructions = res3.data.verification_instructions;
										that.form.end_time = moment(res3.data.end_time * 1000).format('YYYY-MM-DD');
										that.$nextTick(() => {
											that.form.implementor = res3.data.implementor;
										});
										that.affectedFiles = res3.data.filelist;
									}
								});
							}
						}
					});
				}
			});
		},
		handleAvatarChange(file, fileList) {
			let that = this;
			if (!file && !fileList) return;
			that.selectedFile = file.raw;
			that.fileName = file.name;
			that.$toast.clear();
		},
		beforeAvatarUpload(file) {
			let that = this;
			const maxSize = 10 * 1024 * 1024; // 10MB
			const isLt100M = file.size <= maxSize;
			if (!isLt100M) {
				that.$message.error("Uploaded file size cannot exceed 10 MB");
				return false;
			}
			that.$toast.loading({
				duration: 0,
				forbidClick: true
			});
		},
		// Delete File
		delFile() {
			let that = this;
			that.selectedFile = null;
			that.fileName = '';
			that.$refs.uploadBox.clearFiles();
		},
		//Add Affected Document
		handleAffectFile(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if (valid) {
					capaRootCauseActionAdd({
						capa_id: that.info.id,
						root_cause_id: that.form.root_cause_id,
						capa_type: that.form.capa_type,
						implementation_instructions: that.form.implementation_instructions,
						verification_instructions: that.form.verification_instructions,
						implementor: that.form.implementor,
						end_time: moment(that.form.end_time).valueOf() / 1000,
						id: that.form.id ? that.form.id : ''
					}).then(res => {
						if(res.code == 200) {
							that.form.id = res.data;
							that.dialogVisible = true;
						}
					});
				} else {
					return false;
				}
			});
		},
		handleSave() {
			this.$message.success("Save & Close");
		},
		handleAddOther() {
			this.$message.success("Save & Add Another Action");
		},
		handleCancel() {
			let that = this;
			that.$router.back();
		},
		//Confirm Upload Attachment
		submitForm(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if (valid) {
					if (!that.selectedFile) {
						that.$message.warning("Please upload a file");
						return false;
					}
					that.$toast.loading({ duration: 0, forbidClick: true });
					const formData = new FormData();
					formData.append('files', that.selectedFile);
					formData.append('description', that.ruleForm.description);
					formData.append('capa_id', that.info.id);
					formData.append('root_cause_action_id', that.form.id);
					formData.append('id', '');
					capaUploadsRootCauseActionFile(formData).then(res => {
						if(res.code == 200) {
							that.$toast.clear();
							that.$message.success('Operation Successful');
							setTimeout(() => {
								window.location.reload();
							}, 800);
						}
					});
				} else {
					return false;
				}
			});
		},
		//Save
		submitForm1(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if (valid) {
					that.$toast.loading({ duration: 0, forbidClick: true });
					capaRootCauseActionAdd({
						capa_id: that.info.id,
						root_cause_id: that.form.root_cause_id,
						capa_type: that.form.capa_type,
						implementation_instructions: that.form.implementation_instructions,
						verification_instructions: that.form.verification_instructions,
						implementor: that.form.implementor,
						end_time: moment(that.form.end_time).valueOf() / 1000,
						id: that.form.id ? that.form.id : ''
					}).then(res => {
						if(res.code == 200) {
							that.$toast.clear();
							that.$message.success('Operation Successful');
							setTimeout(() => {
								window.location.reload();
							}, 800);
						}
					});
				} else {
					return false;
				}
			});
		},
		//Delete Affected File
		handleRemove(value) {
			let that = this;
			that.$confirm("Are you sure you want to delete this affected file?？", "Prompt", {
				type: "warning",
			}).then(() => {
				that.$toast.loading({ duration: 0, forbidClick: true });
				capaUploadsRootCauseActionFileDel({ id: value.id }).then((res) => {
					if (res.code == 200) {
						that.$toast.clear();
						that.$message.success("Operation Successful");
						setTimeout(() => {
							window.location.reload();
						}, 800);
					}
				});
			}).catch(() => {});
		},
	},
};
</script>

<style lang="less" scoped>
	.save_box {
		.btn_box {
			text-align: right;

			.btn_el {
				margin-left: 10px;
				padding: 12px 24px;

				.van-button__text {
					font-size: 16px;
				}
			}
		}

		.form_box {
			.input_el {
				.tit {
					padding-bottom: 5px;
					font-size: 14px;
					color: #333333;
				}

				.required::before {
					content: "*";
					color: red;
					margin-right: 2px;
				}
			}
		}
	}

	//Main Content
	.main_main {
		.page_main {
			padding: 18px 20px;

			.btn_el {
				margin: 10px 0 20px 0;

				.tips {
					padding: 6px 8px;
					background-color: #ffb1001a;
					border-radius: 6px;
					font-size: 16px;
					font-weight: bold;
				}
			}
		}

		//Header
		.page_header {
			padding: 0 20px;
			height: 60px;
			line-height: 60px;
			background-color: #d8e4f0;
			font-size: 24px;
			font-weight: bold;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
		}
	}
</style>
<style scoped>
	.main_box {
		height: calc(100vh - 60px);
		overflow-y: auto;
	}

	.main_box .main_main {
		position: relative;
		min-height: calc(100% - 0px);
		max-height: auto;
		background-color: #fafafa;
	}

	.el-header,
	.el-main {
		padding: 0;
	}

	.form-grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
		column-gap: 28px;
		align-items: start;
	}

	.form-col {
		display: flex;
		flex-direction: column;
	}

	.full-width {
		width: 100%;
	}

	.full-width-item {
		margin-top: 8px;
	}

	/* label Style */
	::v-deep .el-form-item__label {
		padding-bottom: 8px;
		font-size: 14px;
		line-height: 20px;
		color: #2f343b;
		font-weight: 700;
	}

	/* Unified Input Style */
	.gray-input {
		background: #e9ecef;
		border: 1px solid #cfd5db;
		color: #2f343b;
		border-radius: 8px;
		padding-left: 15px;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
	}

	.text-tip {
		font-size: 20px;
		font-weight: 700;
		margin-bottom: 20px;
	}

	.required {
		color: #f56c6c;
		margin-left: 2px;
	}

	.tip-box {
		margin: 24px 0 16px;
		padding: 12px 8px;
		background: #fff7e8;
		border-radius: 4px;
		color: #222;
		font-weight: 600;
	}

	.file-panel {
		background: #fff;
		border: 1px solid #dcdfe6;
		margin-top: 40px;
	}

	.panel-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 12px 16px;
	}

	.table-title {
		font-size: 18px;
		font-weight: 700;
		color: #2f343b;
	}

	.search-input {
		width: 220px;
	}

	.file-table {
		width: 100%;
		margin-top: 8px;
	}

	.tit {
		padding-bottom: 5px;
		font-size: 14px;
		color: #333333;
	}

	.required::before {
		content: "*";
		color: red;
		margin-right: 2px;
	}

	.upload-doc-wrapper {
		width: 100%;
		margin-bottom: 40px;
		box-sizing: border-box;
	}

	.upload-title {
		font-size: 16px;
		color: #333;
		margin-bottom: 14px;
		font-weight: 500;
	}

	.required-title {
		position: relative;
		padding-left: 10px;
	}

	.required-title::before {
		content: "*";
		position: absolute;
		left: 0;
		top: 3px;
		color: #f56c6c;
		font-size: 15px;
	}

	.upload-limit {
		color: #666;
		font-weight: 400;
	}

	.upload-box {
		display: flex;
		align-items: center;
		width: 100%;
		height: 44px;
		border: 1px solid #dcdfe6;
		border-radius: 6px;
		overflow: hidden;
		background: #f5f7fa;
	}

	.doc-upload {
		flex-shrink: 0;
	}

	.file-name {
		flex: 1;
		height: 44px;
		line-height: 44px;
		padding: 0 16px;
		font-size: 15px;
		color: #333;
		background: #f5f7fa;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		position: relative;
	}

	.file-name.placeholder {
		color: #999;
	}

	.footer-actions {
		margin-top: 28px;
		text-align: center;
	}

	.footer-actions .el-button {
		padding: 7px 13px;
	}
</style>